import { render } from "./LeaderboardPodiumItem.vue?vue&type=template&id=b8920902&scoped=true&ts=true"
import script from "./LeaderboardPodiumItem.vue?vue&type=script&lang=ts"
export * from "./LeaderboardPodiumItem.vue?vue&type=script&lang=ts"

import "./LeaderboardPodiumItem.vue?vue&type=style&index=0&id=b8920902&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8920902"]])

export default __exports__